import "../../App.css";
import React, { Suspense, lazy, useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Loading from "../../Component/Loading";
import Sidebar from "../../Module/sidebar";
import {
  YoutubeEmpSidebarData,
  YoutubeSidebarData,
} from "../../Module/youtubeSidebarData";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { Logout, setInitialState } from "../../Action/authAction";
import { showSuccessSnackbar } from "../../Action/snackbarAction";
import { useDispatch } from "react-redux";

// Movements of Meeting (same pages as the other panels)
const MovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
const CreateTarget = lazy(() => import("./YoutubeTarget/createTargetYoutube"));
const TargetStatus = lazy(() => import("./YoutubeTarget/targetStatusYoutube"));

function YoutubeDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "YOUTUBE" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);
  return (
    <div className="AppBox">
      <Sidebar
        data={loginType === 2 ? YoutubeEmpSidebarData : YoutubeSidebarData}
      />
      <div className="dashboard">
        {
          <CommonRoutes loginType={loginType} defaultPage={<CreateTarget />}>
            <Route path="/" element={<CreateTarget />} />
            <Route path="createTargetYoutube" element={<CreateTarget />} />
            <Route path="targetStatusYoutube" element={<TargetStatus />} />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route path="editMovementsOfMeeting" element={<EditMovementsOfMeeting />} />
          </CommonRoutes>
        }
      </div>
    </div>
  );
}
export default YoutubeDashboard;
